/**
 * react-query
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var shim = require('use-sync-external-store/shim');

var index = require('../../query-core/build/esm/index.js');

var QueryClientProvider = require('./QueryClientProvider.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useIsMutating(arg1, arg2, arg3) {
  var _index$parseMutationF = index.parseMutationFilterArgs(arg1, arg2, arg3),
      _index$parseMutationF2 = _slicedToArray(_index$parseMutationF, 2),
      filters = _index$parseMutationF2[0],
      _index$parseMutationF3 = _index$parseMutationF2[1],
      options = _index$parseMutationF3 === void 0 ? {} : _index$parseMutationF3;

  var queryClient = QueryClientProvider.useQueryClient({
    context: options.context
  });
  var mutationCache = queryClient.getMutationCache();
  return shim.useSyncExternalStore(React__namespace.useCallback(function (onStoreChange) {
    return mutationCache.subscribe(index.notifyManager.batchCalls(onStoreChange));
  }, [mutationCache]), function () {
    return queryClient.isMutating(filters);
  }, function () {
    return queryClient.isMutating(filters);
  });
}

exports.useIsMutating = useIsMutating;